module.exports = __webpack_public_path__ + "img/CLAMP-O.502b9ee3.svg";